import { useState } from 'react';

/** A casino logo that falls back to its initial, both when none is known and
    when the one that is known fails to load, so a table never shows a broken
    image icon. */
export function Logo({ src, name, className }: { src: string | null; name: string; className: string }) {
  const [failed, setFailed] = useState(false);
  if (!src || failed) return <span className={`${className} blank`} aria-hidden>{name.slice(0, 1)}</span>;
  return <img src={src} alt="" loading="lazy" className={className} onError={() => setFailed(true)} />;
}
